import "core-js/modules/es.array.reverse.js";
var _dec, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import classNames from "classnames";
import { observable, reaction, makeObservable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import styled from "styled-components";
import isDefined from "../../Core/isDefined";
import { UIMode } from "../../Models/MapInteractionMode";
import parseCustomHtmlToReact from "../Custom/parseCustomHtmlToReact";
import { withViewState } from "../Context";
import Styles from "./map-interaction-window.scss";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const MapInteractionWindowWrapper = styled.div.withConfig({
  displayName: "MapInteractionWindow__MapInteractionWindowWrapper",
  componentId: "sc-11tk3s1-0"
})(["", ""], props => props.isDiffTool && "\n    display: none;\n    top: initial;\n    bottom: 100px;\n    min-width: 330px;\n    width: auto;\n\n    box-sizing: border-box;\n    padding: 10px 15px;\n    background: ".concat(props.theme.colorSecondary, ";\n    color:").concat(props.theme.textLight, ";\n  "));
let MapInteractionWindow = (_dec = observable.ref, observer(_class = (_class2 = class MapInteractionWindow extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "displayName", "MapInteractionWindow");
    _defineProperty(this, "disposeMapInteractionObserver", void 0);
    _initializerDefineProperty(this, "currentInteractionMode", _descriptor, this);
    _initializerDefineProperty(this, "observableViewState", _descriptor2, this);
    makeObservable(this);
    this.observableViewState = props.viewState;
  }
  componentWillUnmount() {
    var _this$currentInteract;
    // this.removeContextItem();
    if (typeof ((_this$currentInteract = this.currentInteractionMode) === null || _this$currentInteract === void 0 ? void 0 : _this$currentInteract.onEnable) === "function") {
      this.currentInteractionMode.onEnable(this.props.viewState);
    }
    if (this.disposeMapInteractionObserver) {
      this.disposeMapInteractionObserver();
    }
  }
  componentDidMount() {
    this.disposeMapInteractionObserver = reaction(() => this.observableViewState.terria.mapInteractionModeStack.length > 0 && this.observableViewState.terria.mapInteractionModeStack[this.observableViewState.terria.mapInteractionModeStack.length - 1], () => {
      var _this$currentInteract2;
      const mapInteractionMode = this.observableViewState.terria.mapInteractionModeStack[this.observableViewState.terria.mapInteractionModeStack.length - 1];
      if (mapInteractionMode !== this.currentInteractionMode) {
        this.currentInteractionMode = mapInteractionMode;
      }
      if (typeof ((_this$currentInteract2 = this.currentInteractionMode) === null || _this$currentInteract2 === void 0 ? void 0 : _this$currentInteract2.onEnable) === "function") {
        this.currentInteractionMode.onEnable(this.props.viewState);
      }
    });
  }
  componentDidUpdate() {
    runInAction(() => {
      this.observableViewState = this.props.viewState;
    });
  }

  // /* eslint-disable-next-line camelcase */
  // UNSAFE_componentWillReceiveProps(nextProps: any) {
  //   // Only enable context item if MapInteractionWindow is rendering
  //   if (isDefined(this.currentInteractionMode)) {
  //     this.enableContextItem(nextProps);
  //   } else {
  //     this.removeContextItem();
  //   }
  // }

  // enableContextItem(props: any) {
  //   this.removeContextItem();
  //   if (
  //     defined(props.viewState.previewedItem) &&
  //     defined(props.viewState.previewedItem.contextItem)
  //   ) {
  //     props.viewState.previewedItem.contextItem.isEnabled = true;
  //     this._lastContextItem = props.viewState.previewedItem.contextItem;
  //   }
  // }

  // removeContextItem() {
  //   if (defined(this._lastContextItem)) {
  //     this._lastContextItem.isEnabled = false;
  //     this._lastContextItem = undefined;
  //   }
  // }

  render() {
    var _this$currentInteract3, _this$currentInteract4, _this$currentInteract5;
    const isActive = isDefined(this.currentInteractionMode) && !this.currentInteractionMode.invisible;
    const windowClass = classNames(Styles.window, {
      [Styles.isActive]: isActive
    });
    const isDiffTool = ((_this$currentInteract3 = this.currentInteractionMode) === null || _this$currentInteract3 === void 0 ? void 0 : _this$currentInteract3.uiMode) === UIMode.Difference;
    return /*#__PURE__*/_jsxs(MapInteractionWindowWrapper, {
      className: windowClass,
      "aria-hidden": !isActive,
      isDiffTool: isDiffTool,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames({
          [Styles.content]: !isDiffTool
        }),
        children: [isDefined(this.currentInteractionMode) && parseCustomHtmlToReact(this.currentInteractionMode.message()), isDefined(this.currentInteractionMode) && this.currentInteractionMode.messageAsNode()]
      }), typeof ((_this$currentInteract4 = this.currentInteractionMode) === null || _this$currentInteract4 === void 0 ? void 0 : _this$currentInteract4.customUi) === "function" && this.currentInteractionMode.customUi(), ((_this$currentInteract5 = this.currentInteractionMode) === null || _this$currentInteract5 === void 0 ? void 0 : _this$currentInteract5.onCancel) && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: this.currentInteractionMode.onCancel,
        className: Styles.btn,
        children: this.currentInteractionMode.buttonText
      })]
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentInteractionMode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "observableViewState", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export default withViewState(MapInteractionWindow);